import { SET_CONFIG } from '@/store/mutation-types'

export default {
  [SET_CONFIG]: (state, { availableHolidaysProviders = [], ...CONSTS }) => {
    const _availableHolidaysProviders = {}
    availableHolidaysProviders.forEach((provider) => { _availableHolidaysProviders[provider] = true })
    state.CONSTS = {
      ...CONSTS,
      availableHolidaysProviders: _availableHolidaysProviders
    }
  }
}
